/**
 * Path segment after `/api/v1` for the gateway dev token helper.
 * Default `/oauth2/token` (Microsoft). Use `/fusionauth/oauth2/token` when your Swagger flow uses FusionAuth — set `VITE_DEV_OAUTH_TOKEN_PATH` in `apps/webapp/client/.env` and restart the dev server.
 */
export function getDevOauthTokenRequestPath(): string {
  const raw = process.env.VITE_DEV_OAUTH_TOKEN_PATH?.trim();
  const p = raw && raw.length > 0 ? raw : '/oauth2/token';
  return p.startsWith('/') ? p : `/${p}`;
}

/** sessionStorage — Entra client credentials (POST /oauth2/token), shared by dev/test and console demo. */
export const DEV_ENTRA_TOKEN_KEY = 'dev-test-page-entra-access-token';
export const DEV_ENTRA_EXPIRES_AT_KEY = 'dev-test-page-entra-expires-at';
/** Same flow as token: application (client) id used for the last successful client_credentials exchange. */
export const DEV_ENTRA_CLIENT_ID_KEY = 'dev-test-page-entra-client-id';

export interface DevEntraTokenResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
}
